var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTusdLogoApp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.95428 0 0 8.95432 0 20C0 31.0457 8.95428 40 20 40C31.0457 40 40 31.0457 40 20C40 8.95432 31.0457 0 20 0ZM10 11H16.6667C16.6667 14.6819 13.6819 17.6667 10 17.6667V11ZM16.6667 17.6667C16.6667 13.9848 19.6514 11 23.3333 11H30V17.6667H23.3333V31H16.6667V17.6667Z",
    fill: "#1A5AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTusdLogoApp);
export default __webpack_public_path__ + "static/media/tusd-logo-app.fcd8956b9b0e7d658b50daabf9a357aa.svg";
export { ForwardRef as ReactComponent };